<main>
  <div class="transaction-details-wrapper">

    <h1>{{$Locale.get("transaction/title")}}</h1>
    <lib-breadcrumbs [steps]="breadcrumbsSteps"></lib-breadcrumbs>
    
    <div class="panel-wrapper">
      <div class="panel-content">
        <mat-form-field appearance="fill">
          <mat-label>{{$Locale.get("transaction/search")}}</mat-label>
          <input type="text" matInput (input)="tree.filterNodes($event.target.value)">
        </mat-form-field>
        <div class="action-buttons">
          <button mat-stroked-button (click)="tree.expandAll()">{{$Locale.get("transaction/expand")}}</button>
          <button mat-stroked-button (click)="tree.collapseAll()">{{$Locale.get("transaction/collapse")}}</button>
          <button mat-stroked-button (click)="openJsonModal()">{{$Locale.get("transaction/raw")}}<mat-icon>code</mat-icon></button>
        </div>
      </div>
      <app-data-tree [data]="data" [targetName]="config.targetName" [flatten]="config.flatten" [defaultExpanded]="config.defaultExpanded"></app-data-tree>
      <ng-container *ngIf="tree.headerNodes && tree.headerNodes.length && config.flatten">
        <div class="navigate-to">
          <p>Navigate to:</p>
          <mat-divider></mat-divider>
          <button mat-button (click)="handleNodeNavigation(null)">↑ Top</button>
          <button mat-button *ngFor="let node of tree.topLevelNodes" (click)="handleNodeNavigation(node)">{{node.name}}</button>
        </div>
      </ng-container>
    </div>
  </div>
</main>
